import { render, staticRenderFns } from "./SupervisorSettings.vue?vue&type=template&id=285b3e2e&scoped=true&"
import script from "./SupervisorSettings.vue?vue&type=script&lang=js&"
export * from "./SupervisorSettings.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorSettings.vue?vue&type=style&index=0&id=285b3e2e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b3e2e",
  null
  
)

export default component.exports